import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import {
  updateSingleDayShift,
  updateSpecificDay,
} from '@src/helpers/shiftHelpers'
import { TDay, TSingleDayShift } from '@src/helpers/shiftHelpers/types'
import { SHIFT_TYPE } from '@network/models/shift.model'
import { FormikProps } from 'formik'

export const handleBreakChange = (
  selected: any,
  formik: FormikProps<IScheduleSectionFormValues>,
  day: TSingleDayShift | TDay,
) => {
  const {
    values: { days, type, single_day_shifts },
    setFieldValue,
  } = formik
  const { id } = day

  if (type === SHIFT_TYPE.SINGLEDAY) {
    setFieldValue(
      'single_day_shifts',
      updateSingleDayShift(single_day_shifts, String(id), {
        break: Number(selected.value),
      }),
    )
  }

  if (type === SHIFT_TYPE.MULTIDAY) {
    const updatedDays = updateSpecificDay(days, Number(id), {
      break: selected.value,
      is_dirty: true,
    })

    setFieldValue('days', updatedDays)
  }
}
